<header>
	<div class="logo" *ngIf="!headerLogoOverride"></div>
	<img class="logo-override" *ngIf="headerLogoOverride" [src]="headerLogoOverride" alt="" />
	<span class="material-symbols-outlined hamburger mobile" (click)="menuOpen = !menuOpen">menu</span>
	<ul [ngClass]="{ open: menuOpen }">
		<li [ngClass]="{ active: activeLink == 'home' }"><a [routerLink]="['/home']" [interact]="{ engagementTypeID: 4, resource: '/home/' }">Home</a></li>
		<li [ngClass]="{ active: activeLink == 'learn-more' }"><a [routerLink]="['/learn-more']" [interact]="{ engagementTypeID: 4, resource: '/learn-more/' }">Learn More</a></li>
		<li class="language-selector-item"><app-language-selector></app-language-selector></li>
	</ul>
</header>
<router-outlet></router-outlet>

<footer *ngIf="employer" [class.branded]="!!footerLogoOverride">
	<!-- Footer Logo Override: one combined-lockup banner replaces both footer logos -->
	<img class="footer-banner" *ngIf="footerLogoOverride" [src]="footerLogoOverride" alt="" />
	<div class="logo" *ngIf="!footerLogoOverride"></div>
	<div class="socials">
		<ul>
			<li><a href="{{ socialLinks.LinkedIn }}" target="_blank" style="background-image: url(/assets/images/linked-in.svg)" [interact]="{ engagementTypeID: 4, resource: 'Linked In' }"></a></li>
			<li><a href="{{ socialLinks.Facebook }}" target="_blank" style="background-image: url(/assets/images/facebook.svg)" [interact]="{ engagementTypeID: 4, resource: 'Facebook' }"></a></li>
			<li><a href="{{ socialLinks.Instagram }}" target="_blank" style="background-image: url(/assets/images/instagram.svg)" [interact]="{ engagementTypeID: 4, resource: 'Instagram' }"></a></li>
		</ul>
	</div>
	<div class="company-logo" *ngIf="!footerLogoOverride" [ngStyle]="{ 'background-image': 'url(' + logo + ')' }"></div>
</footer>
